import { memo } from 'react';
import cn from 'classnames';
import { Grid, Accordion, AccordionGroup } from 'ht-styleguide';
import { SkuFaq } from 'types/sku.types';
import styles from './faq.module.scss';

type SkuItemFaqProps = {
  items: SkuFaq[];
  className?: string;
  titleClasses?: string;
};

const SkuItemFaq = ({ items, className, titleClasses }: SkuItemFaqProps) => {
  if (!items || items.length === 0) return null;

  return (
    <>
      <Grid.FullWidth classes={cn(className, 'paddingY-large1 marginAuto')}>
        <Grid.Row classes={styles.customRow}>
          <Grid.Column sm={4} md={8} lg={12}>
            <h4 className={cn(titleClasses, 'text-align-center text-weight-medium')}>Frequently Asked Questions</h4>
          </Grid.Column>
          <Grid.Column sm={4} mdOffset={1} md={6} lg={6} lgOffset={3} classes="paddingX-small1">
            <AccordionGroup className={styles.list}>
              {items.map(f => (
                <Accordion key={f.id} title={f.questionText} className={styles.item}>
                  <div className={cn('p1')}>{f.answerText}</div>
                </Accordion>
              ))}
            </AccordionGroup>
          </Grid.Column>
        </Grid.Row>
      </Grid.FullWidth>
      <style jsx>{`
        .accordion_group__item {
        }
      `}</style>
    </>
  );
};
export default memo(SkuItemFaq);
